import { AutogenLayoutServiceTransitTimeMaster } from "./autogen/AutogenLayoutServiceTransitTimeMaster";
import { DataHeader, LookupModelSelectionEvent } from "@mcleod/components";

export class ServiceTransitTimeMaster extends AutogenLayoutServiceTransitTimeMaster {
    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.promptToSaveChanges();
    }
    /** This is an event handler for the onLookupModelSelection event of textboxPayeeId. */
    textboxPayeeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            this.activeRow.set("name", event.selection.get("name"));
        }
    }
}
